<div class="main-layout">
  <app-header></app-header>
  @if (welcomeVisible) {
    <div class="welcome-banner" role="status">
      <div class="welcome-banner-inner container">
        <div class="welcome-banner-accent" aria-hidden="true"></div>
        <div class="welcome-banner-content">
          <p class="welcome-banner-title">{{ 'welcome.bannerTitle' | translate }}</p>
          <p class="welcome-banner-text">{{ 'welcome.bannerMessage' | translate }}</p>
        </div>
        <button type="button" class="welcome-banner-dismiss" (click)="dismissWelcome()" [attr.aria-label]="'welcome.dismissAria' | translate">
          {{ 'welcome.dismiss' | translate }}
        </button>
      </div>
    </div>
  }
  <main>
    <router-outlet></router-outlet>
  </main>
  <app-footer></app-footer>
</div>
